import type { SkeletorOptions } from "./types"
import { warn } from "vue"
import { DEFAULT_OPTIONS, SkeletorSymbol } from "./constants"

export default function useSkeletor(): unknown {
  const skeletor = inject<SkeletorOptions>(
    SkeletorSymbol,
    DEFAULT_OPTIONS,
  )

  if (!skeletor) {
    warn("Skeletor is not installed on this Vue application.")
  }

  return skeletor
}
